import dashboardApi from 'services/api/dashboard'

import TextInput from '../../../../components/ReusableComponents/ManageHotel/TextInput/index'
import useFirstRender from '../../../../hooks/useFirstRender'

const ReservationHotlineInput = ({
  setPhoneValid,
  onChange,
  setFormData,
  value,
  isDisabled,
  ...inputProps
}) => {
  useFirstRender(() => {
    if (value) {
      setPhoneValid(true)
    }
  })

  async function handlePhoneChange(e) {
    onChange(e)

    if (!e.target.value) {
      return
    }

    if (e.target.value && e.target.value.length > 6) {
      const reservationHotline = await dashboardApi.checkPhoneNumber(e.target.value)

      if (reservationHotline) {
        setFormData({ reservationHotline })
        setPhoneValid(true)
        return
      }
    }

    setPhoneValid(false)
  }

  return (
    <TextInput
      name="reservationHotLine"
      {...inputProps}
      label="Reservation hotline"
      onChange={handlePhoneChange}
      value={value}
      style={{ width: 236 }}
      disabled={isDisabled}
    />
  )
}

export default ReservationHotlineInput
